import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FirebaseX } from '@awesome-cordova-plugins/firebase-x/ngx';

import { FirebaseServiceFactory } from './services/firebase/firebase.factory';
import { FirebaseAndroidService } from './services/firebase/firebase-android.service';
import { FirebaseIosService } from './services/firebase/firebase-ios.service';
import { FirebaseMockService } from './services/firebase/firebase-mock.service';
import { FirebaseBrowserService } from './services/firebase/firebase-browser.service';

/**
 * CoreModule contains singleton services that should be loaded only once
 * 
 * Includes:
 * - Firebase services (Android/iOS/Mock implementations)
 * - Other singleton services
 */
@NgModule({
  imports: [CommonModule],
  providers: [
    FirebaseX,
    FirebaseAndroidService,
    FirebaseIosService,
    FirebaseMockService,
    FirebaseBrowserService,
    FirebaseServiceFactory
  ]
})
export class CoreModule {}